import { render, staticRenderFns } from "./snakeBiteDis.vue?vue&type=template&id=7a9ea235"
import script from "./snakeBiteDis.vue?vue&type=script&lang=js"
export * from "./snakeBiteDis.vue?vue&type=script&lang=js"
import style0 from "./snakeBiteDis.vue?vue&type=style&index=0&id=7a9ea235&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports